import React from 'react';
import { View, Text, StyleSheet } from 'react-native';

export default function RewardPin({ isGift, label, value, color, pinColor, size, glowing }) {
  var isLarge = size === 'large';
  var pinSize = isLarge ? 110 : 62;
  var fontSize = isLarge ? 11 : 6;
  var valueSize = isLarge ? 26 : 13;
  var logoW = isLarge ? 56 : 32;
  var logoH = isLarge ? 38 : 22;
  var triW = isLarge ? 18 : 12;
  var triH = isLarge ? 28 : 20;

  return (
    <View style={[s.wrap, glowing && s.glowing]}>
      <View style={[s.circle, { width: pinSize, height: pinSize, borderRadius: pinSize / 2, backgroundColor: pinColor }]}>
        {isGift ? (
          <View style={s.inner}>
            <View style={[s.logo, { width: logoW, height: logoH }]}>
              <Text style={[s.logoText, { fontSize: fontSize, color: color }]} numberOfLines={1}>{label}</Text>
            </View>
            <Text style={[s.value, { fontSize: valueSize }]}>{value}</Text>
          </View>
        ) : (
          <View style={s.inner}>
            <Text style={[s.appLabel, { fontSize: isLarge ? 13 : 7 }]}>{label}</Text>
            <Text style={[s.value, { fontSize: isLarge ? 22 : 12 }]}>{value}</Text>
          </View>
        )}
      </View>
      <View style={[s.triangle, {
        borderLeftWidth: triW,
        borderRightWidth: triW,
        borderTopWidth: triH,
        borderTopColor: pinColor,
      }]} />
    </View>
  );
}

var s = StyleSheet.create({
  wrap: {
    alignItems: 'center',
  },
  glowing: {
    shadowColor: '#3A7CA5',
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 0.7,
    shadowRadius: 25,
    elevation: 10,
  },
  circle: {
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1.5,
    borderColor: 'rgba(100,160,200,0.4)',
  },
  inner: {
    alignItems: 'center',
  },
  logo: {
    borderRadius: 4,
    backgroundColor: '#fff',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 2,
  },
  logoText: {
    fontWeight: '800',
    textAlign: 'center',
  },
  value: {
    fontWeight: '800',
    color: '#fff',
  },
  appLabel: {
    color: 'rgba(255,255,255,0.85)',
    fontWeight: '600',
  },
  triangle: {
    width: 0,
    height: 0,
    borderLeftColor: 'transparent',
    borderRightColor: 'transparent',
    marginTop: -2,
  },
});
